export default __webpack_public_path__ + "static/media/icon-calendar.206004ff.svg";